import React, { useEffect, useState } from 'react';
import useAxios from 'axios-hooks';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, Paper } from '@material-ui/core';
import { GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid';

import AgentLookupResultsSkeleton from './AgentLookupResultsSkeleton';
import { Alert, Button, DataGrid } from 'components/AORedesign';
import { GET_ALL_AGENTS } from '../../constants/api';
import { mapAgentsResponse } from './AgentLookupModal.api';

const AgentLookupModal = ({ open, lineOfBusiness, setOpen, setAgentCode, dataGridProps }) => {
  // Agents state variables
  const [agents, setAgents] = useState(null);
  // const [gridColumns] = useState();
  const gridColumns = [
    {
      field: 'agencyCode',
      headerName: 'Location',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (cellValues) => {
        const agencyCode = cellValues.row?.agencyCode;
        return (
          <Button
            variant="text"
            color="primary"
            onClick={() => {
              handleAgentLookupModalClose(cellValues.row.agencyCode);
            }}>
            {agencyCode}
          </Button>
        );
      },
    },
    {
      field: 'agencyName',
      headerName: 'Location Name',
      editable: false,
      sortable: false,
      flex: 1,
    },
  ];

  // Get all agents
  const getAllAgentsUrl = `${GET_ALL_AGENTS}/${lineOfBusiness}`;
  const [{ data: response, loading, error }] = useAxios(getAllAgentsUrl);

  // Remap agents response
  useEffect(() => {
    if (!loading) {
      setAgents(mapAgentsResponse(response));
    }
  }, [loading, response]);


  // DataGrid custom toolbar to only display the filter icon
  const CustomDataGridToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  };

  const handleAgentLookupModalClose = (selectedAgentCode) => {
    if (selectedAgentCode) {
      setAgentCode(selectedAgentCode);
    }
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleAgentLookupModalClose()}
      disableEnforceFocus
      aria-label="agent-lookup-modal"
      aria-labelledby="agent-lookup-modal-title"
      aria-describedby="agent-lookup-modal-description"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper style={{ padding: `1rem` }}>
        <Box sx={{ width: 800, height: 650 }}>
          <Box mb={2}>
            <Typography variant="h6">Agent Codes</Typography>
          </Box>
          <Box sx={{ height: 550 }} mb={2}>
            {loading ? (
              <AgentLookupResultsSkeleton />
            ) : error ? (
              <Alert severity="error" message={error.message} />
            ) : (
              <DataGrid
                rows={agents}
                columns={gridColumns}
                loading={loading}
                error={error}
                density="compact"
                disableColumnSelector
                autoHeight
                autoPageSize
                components={{
                  Toolbar: CustomDataGridToolbar,
                }}
                {...dataGridProps}
              />
            )}
          </Box>
          <Box>
            <Button
              id="closeButton"
              variant="contained"
              color="primary"
              onClick={() => handleAgentLookupModalClose()}>
              Close
            </Button>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

AgentLookupModal.propTypes = {
  lineOfBusiness: PropTypes.string,
  open: PropTypes.bool,
  setAgentCode: PropTypes.func,
  setOpen: PropTypes.func,
  dataGridProps: PropTypes.object,
};

export default AgentLookupModal;
